import { PageRef } from 'providers/page-ref';

export type EquipmentSearchPageParams = {
  selectedItemId?: string;
  exercise?: string;
  returnCallback?: string;
  local?: {
    returnContext?: unknown;
  };
};

export const IEquipmentSearchPage: PageRef<EquipmentSearchPageParams, void> = {
  pageName: 'EquipmentSearchPage',
} as PageRef<EquipmentSearchPageParams, void>;
